import React, { useState, useEffect } from "react";
import classes from "./EditPinInput.module.css";
import SettingCogIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/__Admin - Settings.svg";
import { Checkbox } from "primereact/checkbox";
import { pinFormat } from "../../../../../../helpers/PinFormat";


const EditPinInput = ({ InputPin, polarity, HandleShowEditPinForm, setPinDetails, selectedPins, setSelectedPins }) => {
    const { pinName, pinStatusOff, pinStatusOn, pinState, icon, active, notificationActive, type, Pin } = InputPin

    const image = icon + " - Off";
    const otherStateImage = icon + " - On";
    const staticPath = "/assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/";

    const imageFromPath = `${process.env.PUBLIC_URL}${staticPath}${image}.svg`
    let otherStateImageFromPath = `${process.env.PUBLIC_URL}${staticPath}${otherStateImage}.svg`;

    const initialPinState = polarity === 1 ? !pinState : pinState;
    const [PinState, setPinState] = useState(initialPinState);

    const isSelected = selectedPins?.has(Pin);

    const toggleSelected = (e) => {
        setSelectedPins(prev => {
            const next = new Set(prev);
            if (e.checked) {
                next.add(Pin);
            } else {
                next.delete(Pin);
            }
            return next;
        });
    };

    useEffect(() => {
        setPinState(pinState);
    }, [pinState]);

    return (
        <div className={classes["layout"]}>
            <div className={classes["pin-output"]} onClick={() => {HandleShowEditPinForm(); setPinDetails({ InputPin }) }}>

                {/* <img className={classes.img} src={!active ? PinState ? imageFromPath : otherStateImageFromPath : InactiveIcon} /> */}

                <img className={classes.img} src={SettingCogIcon} />

                <div className={classes["text-wrapper"]}>
                    <h3 style={{color:"#919191", fontWeight:"450", marginBottom:"10px"}}>{pinName}</h3>
                    <h2 className={`${classes["pinLable"]} ${active ? classes["active"] : classes["Inactive"]}`}>
                        {active ? "Visible in app" : "Not visible in app"}
                    </h2>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: 'auto', marginRight: '15px', gap: '12px' }}>
                    <Checkbox
                        checked={isSelected}
                        onChange={toggleSelected}
                        onClick={(e) => e.stopPropagation()}
                    />
                    <p style={{ margin: 0, color: '#a9a9a9' }}>{pinFormat.Input[Pin]}</p>
                </div>
            </div>
            <div className={active ? classes["pin-active"] : classes["pin-Inactive"]} />
        </div>
    )
}

export default EditPinInput;